"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AccordionHeader = require("../AccordionHeader/AccordionHeader");
var _AccordionItem = require("../AccordionItem/AccordionItem");
var _AccordionPanel = require("../AccordionPanel/AccordionPanel");
var _ControlledAccordion = require("./ControlledAccordion");
var _excluded = ["expanded", "defaultExpanded", "onChange"];
/**
 * @subcomponents ['Accordion.Item', 'Accordion.Header', 'Accordion.Panel']
 * @since 8.43.0
 */

var Accordion = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var controlledExpanded = _ref.expanded,
    _ref$defaultExpanded = _ref.defaultExpanded,
    defaultExpanded = _ref$defaultExpanded === void 0 ? [] : _ref$defaultExpanded,
    onChange = _ref.onChange,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(defaultExpanded),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    uncontrolledExpanded = _useState2[0],
    setUncontrolledExpanded = _useState2[1];
  var onChangeCallback = (0, _react.useCallback)(function (newValue, nextState) {
    setUncontrolledExpanded(nextState);
    if (typeof onChange === 'function') {
      onChange(newValue, nextState);
    }
  }, [onChange, setUncontrolledExpanded]);
  return /*#__PURE__*/_react.default.createElement(_ControlledAccordion.ControlledAccordion, (0, _extends2.default)({
    ref: forwardedRef,
    expanded: typeof controlledExpanded !== 'undefined' ? controlledExpanded : uncontrolledExpanded,
    onChange: onChangeCallback
  }, rest));
});
exports.Accordion = Accordion;
Accordion.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any,
  children: _propTypes.default.node.isRequired,
  /**
   * A default value for the expanded panel's index, or indices, in an uncontrolled accordion
   * component when it is initially rendered.
   */
  defaultExpanded: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
  /**
   * The index, or array of indices, for expanded accordion panels. The `expanded` prop should be
   * used along with `onChange` prop to create controlled accordion component.
   *
   * @ignoreInControls
   */
  expanded: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
  /**
   * The callback for when accordion state has changed.
   *
   * This function will be passed the selected panel's `index` and the `nextState` as index or
   * array of indices.
   *
   * @ignoreInControls
   */
  onChange: _propTypes.default.func,
  /**
   * The callback for when accordion focus has changed.
   *
   * This function will be passed the focused panel's `index`.
   *
   * @ignoreInControls
   */
  onPanelFocus: _propTypes.default.func
} : {};
Accordion.displayName = 'Accordion';
Accordion.Item = _AccordionItem.AccordionItem;
Accordion.Header = _AccordionHeader.AccordionHeader;
Accordion.Panel = _AccordionPanel.AccordionPanel;